<template>
  <nav class="header-main navbar-height navbar navbar-expand-lg fixed-top" data-bs-theme="light">
    <div class="container-fluid d-flex align-items-center justify-content-start"> <!-- Added Bootstrap classes for alignment -->
      <!-- Icon -->
      <img src="@/assets/design.png" width="80" class="me-4"/>

      <!-- <span class="header-label me-4 iot-station ">IoT Station</span> -->
      <img src="@/assets/apex.png" width="32.6" class="me-4"/>
      <span class="customer-header-label me-4" ><strong class="me-2">customer:</strong>  <img src="@/assets/sail.png" width="32.6" class="me-2"/>SAIL(Bokaro Steel Plant)</span>
      <!-- Text-based breadcrumbs -->
      <span class="header-label custom-breadcrumb me-1">{{ breadcrumsfirst }}</span>
<span class="breadcrumb-separator custom-breadcrumb me-1">/</span>
<span class="header-label custom-breadcrumb large-margin"><a class="text-decoration-none">{{ breadcrumslast }}</a></span>

            <!-- <div class="form-group">
              <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown" id="autoSizingSelect">
                <option>Select Option</option>
              </select>
            </div> -->
          </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  props: {
    breadcrumsfirst: String,
    breadcrumslast: String
  },
}
</script>

<style>
.large-margin{
  margin-right: 150px;
}
.customer-header-label{
font-size: 13px; 
}
</style>
